import "./animations.css";

const COLORS = ["#22c55e", "#06b6d4", "#f59e0b", "#ec4899", "#8b5cf6"];

export function fireConfetti(count = 50): void {
  if (typeof document === "undefined") return;
  for (let i = 0; i < count; i++) {
    const el = document.createElement("div");
    el.className = "confetti-particle";
    const dx = (Math.random() - 0.5) * window.innerWidth * 0.8;
    el.style.left = `calc(50% + ${dx}px)`;
    el.style.background = COLORS[i % COLORS.length];
    el.style.animationDelay = `${Math.random() * 200}ms`;
    el.style.animationDuration = `${1000 + Math.random() * 600}ms`;
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 2000);
  }
}

/** Animate a number counter via requestAnimationFrame. */
export function animateCount(
  from: number,
  to: number,
  durationMs: number,
  onTick: (value: number) => void,
): () => void {
  const start = performance.now();
  let raf = 0;
  const tick = (now: number) => {
    const t = Math.min(1, (now - start) / durationMs);
    const eased = 1 - Math.pow(1 - t, 3);
    onTick(Math.round(from + (to - from) * eased));
    if (t < 1) raf = requestAnimationFrame(tick);
  };
  raf = requestAnimationFrame(tick);
  return () => cancelAnimationFrame(raf);
}
